import { FC } from 'react'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  name: string
  src?: string
  onClick: () => void
  imageStyleType: 'square' | 'circle' | 'none'
  testid?: string
}

export const SelectionOptionPanel: FC<Props> = ({ name, src = '', onClick, imageStyleType, testid }) => {
  const className = classNames(styles.image, {
    [styles.square]: imageStyleType === 'square',
    [styles.circle]: imageStyleType === 'circle',
    [styles.none]: imageStyleType === 'none',
  })
  return (
    <button type='button' className={styles.container} onClick={onClick} data-testid={testid}>
      <img className={className} src={imageStyleType === 'none' ? '/images/common/default_logo.svg' : src} alt={name} />
      <div className={styles.name}>{name}</div>
    </button>
  )
}
